<template>
  <div v-if="ready" data-ui="product-formular-parent-div" class="flex gap-2 flex-col w-full">
    <div v-if="product.productId !== 0 && showArticleNumberInput" class="flex w-full  justify-items-end ">
      <div class="overflow-auto flex  w-full justify-start items-end ">

        <div class="flex-grow"></div>
        <div v-for="formName in formNames" :key="formName.idForm" class="mr-1 mt-1 bg-trader-green ">
          <button @click="switchForm(formName.idForm)" :data-ui="formName.name"
                  :class="{'bg-trader-blue text-white': selectedFormId === formName.idForm, 'bg-white text-black': selectedFormId !== formName.idForm}"
                  class="w-full whitespace-nowrap px-2 py-1 hover:bg-trader-blue hover:text-white cursor-pointer flex justify-center items-center">
            {{ formName.name }}
          </button>

        </div>

      </div>
    </div>

    <div v-if="product.virtualOriginalLastChange > 0" class="text-red-400 p-1">
      <i class="fa-solid fa-triangle-exclamation"></i>
      Der Original Artikel wurde am {{ Helper.unixToDateTime(product.virtualOriginalLastChange) }} geändert
    </div>

    <a v-if="product.virtualProjektId"
       :href="goToVirtualPage(product.virtualProjektId, product.virtualMagazineId,product.virtualPagePosition, product.virtualMarketId, product.virtualAccordionIndex)"
       class="flex gap-2 items-center bg-trader-dark-gray p-1 hover:text-trader-blue cursor-pointer">
      <i class="fa-solid fa-link"></i>
      <span>{{ product.virtualProjektName }}</span>
      <i class="fa-solid fa-arrow-right"></i>
      <span>{{ product.virtualMagazineName }}</span>
      <i class="fa-solid fa-arrow-right"></i>
      <span>{{ product.virtualPagePosition }}</span>
      <i v-if="product.virtualMarketName" class="fa-solid fa-arrow-right"></i>
      <span v-if="product.virtualMarketName">{{ product.virtualMarketName }}</span>

      <i class="fa-solid fa-arrow-right"></i>
      <span>{{ productData.articleNumber }}</span>
    </a>


    <button v-if="product.virtualProjektId"
            class="bg-trader-gray text-whites w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
            @click="copyDataFromLinktArticle" data-ui="button-page-view-save-page-changes">
      Änderung vom original Artikel übernehmen
    </button>

    <!--
    <div class="flex-grow flex gap-4 ">
      <div class="flex-col">
        <p class="font-bold">Projekt:</p>
        <span >{{ product.virtualProjektName }}</span>

      </div>
      <div class="flex-col">
        <p>Magazine:</p>
        <span>{{ product.virtualMagazineName }}</span>

      </div>
      <div class="flex-col">
        <p>Seite:</p>
        <span>{{ product.virtualPagePosition }}</span>

      </div>
      <div class="flex-col " v-if="product.virtualMarketName">
        <p>Markt:</p>
        <span>{{ product.virtualMarketName }}</span>
      </div>
    </div>
    -->

    <div class="flex py-4">

      <div v-if="product.productId === 0 && showArticleNumberInput" class="flex w-full">
        <div v-if="isPageLocked" class="flex flex-col w-full my-4 electron:text-center">
          <h2 class="font-bold">Auf dieser Position liegt noch kein Artikel.</h2>
        </div>
        <div v-else class="flex flex-col w-full my-4 electron:text-center">
          <h2 class="font-bold">Auf dieser Position liegt noch kein Artikel.</h2>
          <p>Bitte geben Sie eine Artikelnummer ein, um einen vorhandenen Artikel auf dieser Position zu platzieren oder
            um
            einen neuen Artikel anzulegen.</p>
          <div class="flex flex-row my-4 w-full items-center">
            <span class="mr-4 ">Art.Nr.</span>
            <input v-model="articleNumber"
                   ref="articleNumberInput"
                   class="border border-trader-input-border p-1 shadow-inner-2 w-full"
                   type="text" data-ui="product-input-field" @keyup.enter="placeProduct">


            <i class="fa-solid fa-plus ml-2 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text"
               @click="placeProduct" data-ui="place-product"></i>
          </div>
          <div class=" text-center gap-2 flex items-center justify-center">
            <!--
            <button @click="addArticleNumbers"
                    class="p-2 bg-trader-dark-gray rounded hover:bg-trader-hover-background hover:text-trader-hover-text ">
              Mehrere Artikel hinzufügen
            </button>-->
            <div v-if="articleNumber.includes(',')" class="flex  items-center gap-2">
              <button @click="placeABCArticle = true"
                      :class="{'bg-trader-blue text-white': placeABCArticle, 'bg-trader-gray': !placeABCArticle}"
                      class="px-4 py-2 rounded">
                ABC
              </button>
              <button @click="placeABCArticle = false"
                      :class="{'bg-trader-blue text-white': !placeABCArticle, 'bg-trader-gray': placeABCArticle}"
                      class="px-4 py-2 rounded">
                123
              </button>

            </div>
            <button
                class=" p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text flex gap-2 items-center"
                @click="placeProductFromOtherMagazine"><i
                class="fa-solid fa-link" data-ui="place-product-from-other-magazine"></i>
              Virtuellen Artikel verknüpfen
            </button>
          </div>
        </div>
      </div>
      <div v-else class="flex w-full ">
        <div class="left w-3/5 electron:w-full  mr-4 flex flex-col gap-2" v-if="(typeof product !== 'undefined')">
          <div v-if="!isPageLocked && showArticleNumberInput" class="flex w-[353px] electron:w-full ">
            <div class="w-4/12" data-ui="'label-article-number-fusion'">
              Art.Nr.<br>
              (verschmelzen)
            </div>
            <div class="w-8/12 ">
              <div class="flex">
                <input v-model="articleNumber" type="text"
                       class="border border-trader-input-border w-full p-1 shadow-inner-2"
                       data-ui="input-article-number-fusion" @keyup.enter="placeProduct(event,true)">
                <i class="fa-solid fa-plus ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
                   @click="placeProduct(event,true)" data-ui="place-product-fusion"></i>
              </div>
            </div>
          </div>


          <div class="flex items-top w-[353px] electron:w-full " v-if="showArticleNumberInput">
            <div class="w-4/12 items-center" data-ui="label-article-number">
              Art.Nr.
            </div>
            <div class="p-0 inline-flex w-8/12">
              <div class="w-full flex">

                <div class="w-full flex" v-if="!changeArticleNumberDialog">
                  <input class="border border-trader-input-border p-1 w-full shadow-inner-2"
                         readonly="readonly"
                         v-model="oldArticleNumber"
                         :class="{ 'bg-inactive' : isPageLocked }"
                         type="text" data-ui="input-article-number">
                  <i v-if="!isPageLocked"
                     class="fa-solid fa-pencil ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
                     title="Bearbeiten" data-ui="edit-article-number" @click="changeArticleNumber"></i>
                  <i v-if="!isPageLocked"
                     class="fa-regular fa-clipboard ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
                     title="In die Zwischenablage verschieben" @click="sendProductToClipboard"
                     data-ui="save-article-number"></i>
                  <i v-if="!isPageLocked"
                     class="fa-solid fa-circle-xmark ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
                     title="Löschen" @click="deleteProduct" data-ui="delete-article-number"></i>
                </div>

                <div class="flex w-full " v-else>
                  <input class="border shadow-inner-2 p-1 w-full"
                         v-model="productData.articleNumber"
                         type="text" data-ui="input-article-number">
                  <i class="fa-solid fa-check ml-1 p-2 bg-trader-green hover:bg-trader-hover-background hover:text-trader-hover-text text-trader-dark-green hover:cursor-pointer "
                     title="Sichern" data-ui="save-edit-article-number-changes"
                     @click="saveNewArticleNumber(productData.articleNumber)"></i>
                  <i class="fa-solid fa-circle-xmark ml-1 p-2 bg-trader-red hover:bg-trader-hover-background text-trader-dark-red hover:text-trader-hover-text hover:cursor-pointer"
                     title="Abbrechen" @click="changeArticleNumber()" data-ui="cancel-edit-article-number"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- main form -->

          <div v-if="showPurchaser" class="flex">
            <div class="flex items-top w-full">
              <div class="p-0 w-4/12 electron:w-4/12 flex-shrink-0 items-center" :data-ui="'label-Einkaufsbereich'">
                Einkaufsbereich:
              </div>
              <div class="p-0 flex-grow">
                <select
                    class="border border-trader-input-border p-1 w-full shadow-inner-2" v-model="activePurchaserId"
                    data-ui="select-team-id" :class="{ 'bg-inactive': isPageLocked }" :disabled="isPageLocked">
                  <option :data-ui="purchaser.teamIcon" v-for="purchaser in purchasers" :key="purchaser.id"
                          :value="purchaser.id">
                    {{ purchaser.teamIcon }} - {{ purchaser.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <template v-if="formData !== null"
                    v-for="(formField, index) in formData?.filter((item) => item.groupID === 0)" :key="formField.id">

            <div v-if="formField.formularType !== 'group' " class="flex items-top w-[353px]  electron:w-full">

              <template
                  v-if="customizations?.fieldTypes?.filter((item) => { return item.key == formField.formularType})?.length > 0">
                <template v-for="customization in customizations.fieldTypes">

                  <template v-if="formField.formularType === customization.key">
                    <div v-if="customization?.component?.meta?.hideLabel !== true"
                         class="p-0 w-4/12 items-center shrink-0"
                         :data-ui="'label-'+ formField.label"
                         :title="formField.label + '\nDatabase: ' + formField.field">{{ formField.label }}
                    </div>
                    <div class="p-0 flex-grow flex ">
                      <component :is="customization.component"
                                 :form-field="formField"
                                 :product-data="productData"
                                 :page="page"
                                 :on-change-product-field-value="onChangeProductFieldValue"
                                 :get-field-value="getFieldValue"
                                 :read-only="isPageLocked || formField.readOnly"
                                 :on-form-event="onFormEvent"
                                 :on-blur="onBlurProductField"
                      ></component>
                    </div>
                  </template>


                </template>
              </template>
              <template v-else>


                <div class="p-0 w-4/12 electron:w-4/12  items-center" :data-ui="'label-'+ formField.label"
                     :title="formField.label + '\nDatabase: ' + formField.field">{{ formField.label }}
                </div>
                <div class="p-0 flex-grow ">
                  <input v-if="formField.formularType === 'input'"
                         :readonly="isPageLocked || formField.readOnly"
                         v-model="productData.customFields[formField.field].value"
                         @input="() => onChangeProductFieldValue(formField.field, 'string')"
                         @blur="() => onBlurProductField()"
                         class="border border-trader-input-border p-1 w-full  shadow-inner-2 "
                         :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'bg-trader-red': productData.customFields[formField.field]?.highlight }"
                         :data-ui="'input-'+ formField.label">
                  <input v-if="formField.formularType === 'checkbox'" type="checkbox"
                         class="p-1 w-4 h-4 "
                         :disabled="isPageLocked || formField.readOnly"
                         :checked="getFieldValue(formField.field, 'boolean')"
                         @change="(event) => onChangeProductFieldValue(formField.field, 'boolean', event.target.checked)"
                         @blur="() => onBlurProductField()"
                         :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'shadow-trader-red': productData.customFields[formField.field]?.highlight }"
                         :data-ui="'checkbox-'+ formField.label">
                  <textarea v-if="formField.formularType === 'textarea'"
                            :readonly="isPageLocked || formField.readOnly"
                            v-model="productData.customFields[formField.field].value"
                            @input="() => onChangeProductFieldValue(formField.field)"
                            @blur="() => onBlurProductField()"
                            class="border border-trader-input-border p-1 w-full  shadow-inner-2"
                            :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'bg-trader-red': productData.customFields[formField.field]?.highlight }"
                            :data-ui="'textarea-'+ formField.label"
                  ></textarea>
                </div>
              </template>
            </div>

          </template>


          <!-- from groups -->
          <div class="mt-10"
               v-if="formData !== null && formData?.filter((item) => item.groupID === 0 && item.formularType == 'group').length > 0">
            <accordion ref="accordion">

              <accordion-item v-if="formData !== null"
                              v-for="(group, index) in formData?.filter((item) => item.groupID === 0 && item.formularType == 'group')"
                              :key="group.id" :padding="false">

                <template v-slot:accordionTrigger>
                  <div class="flex items-center justify-center w-full">
                    <span class="w-full pl-2">
                      {{ group.label }}
                    </span>
                  </div>
                </template>
                <!-- accordion content -->
                <template v-slot:accordionContent>

                  <div class="p-2 bg-trader-light-gray">
                    <div class="flex w-full items-center pt-1 pb-1"
                         v-for="(formField, index) in formData?.filter((item) => item.groupID === group.id)">
                      <template
                          v-if="customizations?.fieldTypes?.filter((item) => { return item.key == formField.formularType})?.length > 0">
                        <template v-for="customization in customizations.fieldTypes">
                          <template v-if="formField.formularType === customization.key">
                            <div class="p-0 w-2/4 " v-if="customization?.component?.meta?.hideLabel !== true">
                              {{ formField.label }}
                            </div>
                            <div class="p-0 inline-flex w-full">
                              <component :is="customization.component"
                                         :form-field="formField"
                                         :product-data="productData"
                                         :page="page"
                                         :on-change-product-field-value="onChangeProductFieldValue"
                                         :get-field-value="getFieldValue"
                                         :read-only="isPageLocked || formField.readOnly"
                                         :on-form-event="onFormEvent"
                                         :on-blur="onBlurProductField"
                              >
                              </component>
                            </div>
                          </template>
                        </template>
                      </template>
                      <template v-else>

                        <div class="p-0 w-2/4 ">
                          {{ formField.label }}
                        </div>
                        <div class="p-0 inline-flex w-full">
                          <input v-if="formField.formularType === 'input'"
                                 :readonly="isPageLocked || formField.readOnly"
                                 v-model="productData.customFields[formField.field].value"
                                 @input="() => onChangeProductFieldValue(formField.field, 'string')"
                                 @blur="() => onBlurProductField()"
                                 class="border border-trader-input-border p-1 w-full  shadow-inner-2"
                                 :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'bg-trader-red': productData.customFields[formField.field]?.highlight }">

                          <input v-if="formField.formularType === 'checkbox'" type="checkbox"
                                 class="p-1 w-4 h-4  "
                                 :disabled="isPageLocked || formField.readOnly"
                                 :checked="getFieldValue(formField.field, 'boolean')"
                                 @change="(event) => onChangeProductFieldValue(formField.field, 'boolean', event.target.checked)"
                                 @blur="() => onBlurProductField()"
                                 :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'shadow-trader-red': productData.customFields[formField.field]?.highlight }">

                          <textarea v-if="formField.formularType === 'textarea'"
                                    :readonly="isPageLocked || formField.readOnly"
                                    v-model="productData.customFields[formField.field].value"
                                    @input="() => onChangeProductFieldValue(formField.field)"
                                    @blur="() => onBlurProductField()"
                                    class="border border-trader-input-border p-1 w-full  shadow-inner-2"
                                    :class="{ 'bg-inactive' : isPageLocked || formField.readOnly, 'bg-trader-red': productData.customFields[formField.field]?.highlight }"
                                    :data-ui="''+ formField.formularType"
                          ></textarea>
                        </div>
                      </template>

                    </div>
                  </div>
                </template>
              </accordion-item>

            </accordion>
          </div>
        </div>

        <!-- right side pictures, logos, product preview -->
        <div class="right w-2/5 flex flex-col gap-2 electron:min-w-[200px] electron:max-w-[200px]">
          <!--
          <pre>{{product.productPictures}}</pre>
          -->
          <!-- product pictures -->
          <button v-if="showDraggableButton" class="p-2 w-[200px] bg-white " data-ui="toggleDraggable"
                  @click="toggleDraggable">
            <!-- <i :class="{'fas fa-unlock': isDraggable, 'fas fa-lock': !isDraggable}"></i>-->
            {{ draggableFalse ? 'Bilder sortieren' : 'Bilder ziehen' }}
          </button>
          <div data-allow-drop @dragover.prevent @drop="onDrop($event, 'picture')"
               @mouseleave="() => {this.allowDrop = true}">


            <label>Bilder:</label>
            <!-- Sortiermodus -->
            <div v-if="draggableFalse">
              <draggable
                  ref="myDraggable"
                  class="grid gap-1"
                  :class="runningElectron ? 'grid-cols-2' : 'grid-cols-3'"
                  v-model="productData.productPictures"
                  :animation="200"
                  @update="() => { onSortImages(productData.productPictures) }"
                  :key="productPicturesReload"
              >
                <div v-if="productData.productPictures.length === 0" class="h-20 bg-inactive text-center flex items-center">
                  <span>Keine Abbildung</span>
                </div>
                <ProductFormularImage
                    v-for="(picture, idx) in productData.productPictures"
                    :key="picture.productPictureId || idx"
                    :image="picture"
                    :can-be-default="true"
                    :on-remove="onRemoveImage"
                    :on-set-delete="onSetDeleteImage"
                    :on-change-active="onChangeActiveImage"
                    :on-change-default="onChangeDefaultImage"
                    :on-zoom="onZoomImage"
                    :allow-drag="!draggableFalse"
                    :on-drag-start="() => { this.allowDrop = false }"
                    type="picture"
                    :data-ui="'article_' + productData.articleNumber + '_picture_' + idx"
                    :page-locked="isPageLocked"
                    :show-article-number-input="showArticleNumberInput"
                    :on-click-get-image="onClickGetImage"
                    :index="idx"
                    :selected-index="highlightPicture"
                    :type="'picture'"
                />
              </draggable>
            </div>

            <div v-else class="grid  gap-1"  :class="runningElectron ? 'grid-cols-2' : 'grid-cols-3'">
              <div v-if="productData.productPictures.length === 0" class="h-20 bg-inactive text-center flex items-center">
                <span>Keine Abbildung</span>
              </div>
              <ProductFormularImage
                  v-for="(picture, idx) in productData.productPictures"
                  :key="picture.productPictureId || idx"
                  :image="picture"
                  :can-be-default="true"
                  :on-remove="onRemoveImage"
                  :on-set-delete="onSetDeleteImage"
                  :on-change-active="onChangeActiveImage"
                  :on-change-default="onChangeDefaultImage"
                  :on-zoom="onZoomImage"
                  :allow-drag="!draggableFalse"
                  :on-drag-start="() => { this.allowDrop = false }"
                  type="picture"
                  :data-ui="'article_' + productData.articleNumber + '_picture_' + idx"
                  :page-locked="isPageLocked"
                  :show-article-number-input="showArticleNumberInput"
                  :on-click-get-image="onClickGetImage"
                  :index="idx"
                  :selected-index="highlightPicture"
                  :type="'picture'"
              />
            </div>
          </div>
          <!-- product logos -->
          <div class="" data-allow-drop @dragover.prevent @drop="onDrop($event, 'logo')"
               @click="deactivateDropArea('logo')"
               @mouseleave="() => {this.allowDrop = true}">

            <label>Logos:</label>
            <div class="flex-wrap">
              <div v-if="draggableFalse">
                <draggable
                    class="grid  gap-1"
                    :class="runningElectron ? 'grid-cols-2' : 'grid-cols-3'"
                    v-model="productData.productLogos"
                    :animation="200"
                    @update="() => { onSortImages(productData.productLogos) }"
                >
                  <div v-if="productData.productLogos.length === 0" class="h-20 bg-inactive text-center flex items-center">
                    <span>Keine Abbildung</span>
                  </div>
                  <ProductFormularImage
                      v-for="(logo, idx) in productData.productLogos"
                      :key="logo.productLogoId || idx"
                      :image="logo"
                      :on-remove="onRemoveImage"
                      :on-set-delete="onSetDeleteImage"
                      :on-change-active="onChangeActiveImage"
                      :on-change-default="onChangeDefaultImage"
                      :on-zoom="onZoomImage"
                      :allow-drag="!draggableFalse"
                      :on-drag-start="() => { this.allowDrop = false }"
                      :data-ui="'article_' + productData.articleNumber + '_logo_' + idx"
                      :page-locked="isPageLocked"
                      :show-article-number-input="showArticleNumberInput"
                      :on-click-get-image="onClickGetImage"
                      :index="idx"
                      :selected-index="highlightLogo"
                      :type="'logo'" /> <!-- Das hier hat gefehlt weshalb keine logos angezeigt wurden -->
                </draggable>
              </div>

              <!-- Drag-Modus für Logos (kein draggable-Wrapper) -->
              <div v-else class="grid  gap-1" :class="runningElectron ? 'grid-cols-2' : 'grid-cols-3'">
                <div v-if="productData.productLogos.length === 0" class="h-20 bg-inactive text-center flex items-center">
                  <span>Keine Abbildung</span>
                </div>
                <ProductFormularImage
                    v-for="(logo, idx) in productData.productLogos"
                    :key="logo.productLogoId || idx"
                    :image="logo"
                    :on-remove="onRemoveImage"
                    :on-set-delete="onSetDeleteImage"
                    :on-change-active="onChangeActiveImage"
                    :on-change-default="onChangeDefaultImage"
                    :on-zoom="onZoomImage"
                    :allow-drag="!draggableFalse"
                    :on-drag-start="() => { this.allowDrop = false }"
                    :data-ui="'article_' + productData.articleNumber + '_logo_' + idx"
                    :page-locked="isPageLocked"
                    :show-article-number-input="showArticleNumberInput"
                    :on-click-get-image="onClickGetImage"
                    :index="idx"
                    :selected-index="highlightLogo"
                    :type="'logo'"/> <!-- Das hier hat gefehlt weshalb keine logos angezeigt wurden -->
              </div>
            </div>
          </div>

          <!-- product preview -->
          <div v-if="showPreviewTemplates">
            <label>Vorschau:</label>

            <!--
            <div class="bg-red-600">
            <object type="image/svg+xml" class="w-full h-full"
                    :data="'/api/v3/preview/page/'+this.page.pageId+ '/product/' + this.product.productId + '/template/' + this.formData?.productTemplate?.id">
              <param name="type" value="image/svg+xml">
            </object>
            </div>
            -->


            <!-- {{ product.productId }} - {{ productData.productTemplate.id }} - {{ productData.productTemplate.name }}-->

            <ShowPreviewProduct v-if="showPreviewTemplates && this.active" class="w-full" :h-max="600" :page-id="page.pageId"
                                :product-id="product.productId"
                                :template-id="productData.productTemplate.id"
                                :template-name="productData.productTemplate.name"
                                :highlight="productData.productTemplate.highlight"
                                :show-info="true"
                                :show-options="true"/>


            <div class="flex flex-col gap-2">
              <div class="flex w-full mt-1 gap-1">

                <button v-if="somethingChanged"
                        class="w-full bg-red-400 text-white h-8 p-2 cursor-pointer hover:bg-trader-dark-red text-center whitespace-nowrap"
                        data-ui="button-page-view-reset-page-changes"
                        @click="resetChanges">Änderungen zurücksetzen
                </button>
                <div v-else class="flex-grow w-full">

                </div>

                <button v-if="showPreviewTemplates" @click="showProductPreview" data-ui="open-product-preview"
                        class="px-2 hover:bg-trader-blue hover:text-white text-center cursor-pointer">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>

                <div v-if="showPreviewTemplates && userData?.isAdmin"
                     @click="() => {  openProductTemplateInIndesign({productTemplateId: productData.productTemplate.id}); }"
                     class="px-4 h-8 text-center hover:bg-trader-blue hover:text-white cursor-pointer text-sm bg-indesign-dark text-indesign-light">
                  <div class="leading-8 font-bold ">Id</div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ProductFormularImage from "../ProductFormularPicture/ProductFormularImage";
import {VueDraggableNext} from "vue-draggable-next";
import Accordion from "@/components/Accordion/Accordion";
import AccordionItem from "@/components/Accordion/AccordionItem";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import db from "../../application/db.js";
import ShowPreviewProduct from "@/components/Preview/showPreviewProduct.vue";
import showPreviewProduct from "@/components/Preview/showPreviewProduct.vue";
import SignalBus from "@/application/SignalBus";
import Helper from "@/application/helper";

import {reloadHighlights} from "../../application/Highlighter.js";
import {eventBus} from "@/application/EventBus";
import ImageView from "@/components/Dialogs/ImageView.vue";
import CreateNewArticleNumber from "@/components/ProductFormular/CreateNewArticleNumber.vue";
import {customizations} from "@/customizations/customizations";
import {mapActions, mapGetters, mapState} from "vuex";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import AddArticleNumbers from "@/components/Dialogs/AddArticleNumbers.vue";
import {mutation, query} from "@/graphql";
import PlaceProductFromOtherMagazine from "@/components/Dialogs/PlaceProductFromOtherMagazine.vue";
import TRContainer from "@/components/Base/v2/TRContainer.vue";
import ShowReport from "@/components/Dialogs/ShowReport.vue";
import {ref} from "vue";
import hooks from "@/application/hooks";

export default {

  components: {
    TRContainer,
    ProductFormularImage,
    Accordion,
    AccordionItem,
    draggable: VueDraggableNext,
    ShowPreviewProduct,
    CreateNewArticleNumber,
  },
  props: {
    newImageAdded: {
      type: Function,
      default: () => {
      }
    },
    showDraggableButton: {
      type: Boolean,
      default: false,
    },
    onClickGetImageData: {
      type: Function,
      default: () => {
      }
    },
    showArticleNumberInput: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    productFormFields: {
      type: Array,
      required: false,
    },
    header: {
      type: Boolean,
      required: false,
    },
    formId: {
      type: Number,
      default: 1,
    },
    formNames: {
      type: Array,
      default: [],
    },
    setArticleNumberInput: {
      type: Boolean,
      default: false,
    },
    onClickReloadPage: {
      type: Function,
      default: () => {
      }
    },
    useIndexDB: {
      type: Boolean,
      default: true,
    },
    onChange: {
      type: Function,
      default: () => {
      }
    },
    purchaserId: {
      type: Number, // oder String, je nachdem, was Sie verwenden
      default: 0,
    },
    showPurchaser: {
      type: Boolean,
      default: false,
    },
    draggableFalse: {
      type: Boolean,
      default: true,
    },
    onClickChangeDraggable: {
      type: Function,
      default: () => {
      }
    },
    showPreviewTemplates: {
      type: Boolean,
      default: true,
    }
  },
  //if not, create it else update it
  name: "ProductFormular",
  data() {
    let productObj = {
      articleNumber: "",
      productPictures: [],
      productLogos: [],
      customFields: [],
      productId: this.product.productId,
      isVirtualArticle: this.product.isVirtualArticle,
      virtualMagazineId: this.product.virtualMagazineId,
      virtualPagePosition: this.product.virtualPagePosition,
      virtualMagazineName: this.product.virtualMagazineName,
      virtualMarketId: this.product.virtualMarketId,
      virtualMarketName: this.product.virtualMarketName,
      virtualProjektId: this.product.virtualProjektId,
      virtualProjektName: this.product.virtualProjektName,
      virtualOriginalLastChange: this.product.virtualOriginalLastChange,
      virtualAccordionIndex: this.product.virtualAccordionIndex,
    };
    productObj.articleNumber = this.product.articleNumber;
    productObj.productTemplate = {
      id: this.product.productTemplateId,
      name: this.product.productTemplateName,
      highlight: false,
    }
    if (typeof this.product !== 'undefined') {
      this.product.productCustomFields.forEach(item => {
        if (item.field.trim() !== "") {
          productObj.customFields[item.field.trim()] = {value: item.value, highlight: false};
        }
      });
    }

    //copy pictures
    productObj.productPictures = JSON.parse(JSON.stringify(this.product.productPictures));
    productObj.productLogos = JSON.parse(JSON.stringify(this.product.productLogos));

    //sort pictures
    productObj.productPictures.sort((a, b) => {
      return a.position - b.position;
    });

    //sort logos
    productObj.productLogos.sort((a, b) => {
      return a.position - b.position;
    });

    //set highlight
    productObj.productPictures.forEach((item, index) => {
      item.highlight = false;
      item.orignalPosition = item.position;
      item.isRemoved = false;
    });

    productObj.productLogos.forEach((item, index) => {
      item.highlight = false;
      item.orignalPosition = item.position;
      item.isRemoved = false;
    });


    return {
      productData: productObj,
      resetProductData: JSON.parse(JSON.stringify(productObj)),
      formData: null,
      productIndex: 0,
      articleNumber: "",
      formOption: 2,
      disconnect: null,
      oldArticleNumber: this.product.articleNumber,
      changeArticleNumberDialog: false,
      selectedFormId: this.formId,
      highlightPicture: -1,
      highlightLogo: -1,
      changes: {},
      picturePositionSave: {},
      productPicturesReload: 0,
      //draggableFalse: false,
      purchasers: [],
      activePurchaserId: this.purchaserId,
      allowDrop: true,
      addPictures: [],
      Helper: Helper,
      ready: false,
      formEvents: [],
      placeABCArticle: false,
      runningElectron: ref(window.runningElectron)
    };
  },
  computed: {
    ...mapState('user', ['userData']),
    ...mapGetters('page', ['isPageLocked']),

    customizations() {
      return customizations
    },
    somethingChanged() {
      let changed = false;

      this.productData.productPictures.forEach((item, index) => {

        if (item.highlight) {
          changed = true;
        }
      });
      this.productData.productLogos.forEach((item, index) => {

        if (item.highlight) {
          changed = true;
        }
      });

      for (const [key, value] of Object.entries(this.productData.customFields)) {

        if (value.highlight) {
          changed = true;
        }
      }

      if (this.productData.productTemplate.highlight) {
        changed = true;
      }
      return changed;
    },
  },
  watch: {

    magazineTypeId: {
      handler: function (val) {
        this.formNames.forEach((item) => {
          this.selectedFormId = item.magazineType === val ? item.idForm : this.selectedFormId;
        });
      },
      deep: true
    },
    selectedFormId: {
      handler: function (val, oldVal) {
        this.getFormular();
      },
      deep: true
    },
    formId: {
      handler: function (val, oldVal) {
        this.selectedFormId = val;
      },
      deep: true
    },

  },
  methods: {
    onFormEvent(event, func) {
      this.formEvents.push({event: event, func: func});
    },
    triggerFormEvent(event, payload) {
      this.formEvents.forEach((item) => {
        if (item.event === event) {
          item.func(payload);
        }
      });
    },
    async copyDataFromLinktArticle() {
      const [data, err] = await mutation.copyDataFromLinktArticle(this.product.virtualMagazineId, this.product.virtualMarketId, this.page.pageId, this.product.productId);
      if (err) {
        console.error(err);
      }
      SignalBus.emit("reload-page");
    },
    onDragOver(event) {
      // event.preventDefault(); // Nicht notwendig, wenn Sie .prevent im Template verwenden

    },
    goToVirtualPage(projektId, magazineId, pagePosition, marketId, accordionIndex) {
      return `/project/` + projektId + '/' + magazineId + '/' + pagePosition + '/' + marketId + '/' + accordionIndex;

    },

    preventDefault(e) {
      if (!e.target.closest('[data-allow-drop]')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    deactivateDropArea(type) {

      if (type === 'picture') {
        this.isDropActivePicture = false;
      } else {
        this.isDropActiveLogo = false;
      }

    },
    activateDropArea(type) {
      if (type === 'picture') {
        this.isDropActivePicture = true;
      } else {
        this.isDropActiveLogo = true;
      }
    },
    async onDrop(event, type) {
      event.preventDefault();

      if (!this.allowDrop) {
        return;
      }

      if (this.draggableFalse) {
        return
      }

      const path = window?.electronAPI.showFilePath(event.dataTransfer.files[0]);
      const [data, err] = await query.getImageByPath(path);

      let image = {};
      if (type === 'logo') {
        image = {
          productJoinProductLogoId: 0,
          productLogoId: 0,
          teamId: 0,
          isActive: true,
          previewSmall: data.imgLocNewFilepath,
          previewMedium: data.imgLocNewFilepath,
          previewLarge: data.imgLocNewFilepath,
          position: 1,
          originalFilePath: data.imgLocOrgFilepath,
          markedForDeletion: false,
          isDefault: false,
          name: data.imgLocOrgFilename,
          dateTimeCreated: 0,
          dateTimeUpdated: 0,
          delete: false,
          add: true,
          highlight: true
        }
        if (err) {
          console.error(err);
        }
        this.productData.productLogos.push(image);

        this.productData.productLogos = this.productData.productLogos.filter((pic, index, arr) => {
          // Finde den ERSTEN Index im Array, wo originalFilePath ODER previewSmall übereinstimmt
          const firstIndex = arr.findIndex(
              p => p.originalFilePath === pic.originalFilePath
                  || p.previewSmall === pic.previewSmall
          );
          // Nur wenn "pic" an dieser Position das erste Vorkommen ist, bleibt es drin
          return index === firstIndex;
        });
        let logos = this.productData.productLogos.filter((item) => item.add);
        await this.saveProductState('logo', 'logos', JSON.stringify(logos));
      } else {
        image = {
          productJoinProductPictureId: 0,
          productPictureId: 0,
          teamId: 0,
          isActive: true,
          previewSmall: data.imgLocNewFilepath,
          previewMedium: data.imgLocNewFilepath,
          previewLarge: data.imgLocNewFilepath,
          position: 1,
          originalFilePath: data.imgLocOrgFilepath,
          markedForDeletion: false,
          isDefault: false,
          name: data.imgLocOrgFilename,
          dateTimeCreated: 0,
          dateTimeUpdated: 0,
          delete: false,
          add: true,
          highlight: true
        }


        this.productData.productPictures.push(image);
        this.addPictures.push(image);
        // Entfernt Duplikate anhand originalFilePath ODER previewSmall:
        this.productData.productPictures = this.productData.productPictures.filter((pic, index, arr) => {
          // Finde den ERSTEN Index im Array, wo originalFilePath ODER previewSmall übereinstimmt
          const firstIndex = arr.findIndex(
              p => p.originalFilePath === pic.originalFilePath
                  || p.previewSmall === pic.previewSmall
          );
          // Nur wenn "pic" an dieser Position das erste Vorkommen ist, bleibt es drin
          return index === firstIndex;
        });
        let pictures = this.productData.productPictures.filter((item) => item.add);

        await this.saveProductState('picture', 'pictures', JSON.stringify(pictures));
      }
      await this.newImageAdded(image, type);
    },
    async getPurchasers() {
      const [data, err] = await query.getPurchasers();
      this.purchasers = data;

      if (err) {
        console.error(err);
      }

    },


    toggleDraggable() {
      //  this.draggableFalse = !this.draggableFalse;
      this.onClickChangeDraggable(this.draggableFalse);
    },
    onClickGetImage(image, index) {
      if (image?.productJoinProductPictureId) {
        this.highlightPicture = index;
        this.highlightLogo = -1;
      } else {
        this.highlightPicture = -1;
        this.highlightLogo = index;
      }
      this.onClickGetImageData(image);
    },
    addArticleNumbers() {
      eventBus.openModal(AddArticleNumbers, {
        page: this.page,
        onAccept: (articleNumbers) => {
          this.placeProducts(articleNumbers);
          this.getPage();
        }
      });
    },

    async placeProducts(articleNumbers) {

      let value = {
        articleNumbers: articleNumbers,
        pageId: this.page.pageId,
        placeABCArticle: this.placeABCArticle,
        virtualId: this.product.placeholderId,
      }
      const [data, err] = await query.placeProductsOnPage(value);
      try {
        
        if (!data.success) {
          eventBus.openModal(ShowReport, {
            title: "Report Meldung",
            errors: data.errors,
            messages: data.messages,
          });
        }
      } catch (error) {
        console.error("fehler beim Platzieren der seite", error)
      } finally {

        this.onClickReloadPage();

      }
    },
    ...mapActions('indesign', ['openProductTemplateInIndesign']),
    showProductPreview() {
      eventBus.openModal(showPreviewProduct, {
        pageId: this.page.pageId,
        productId: this.product.productId,
        templateId: this.productData.productTemplate.id,
        templateName: this.productData.productTemplate.name,
        showOptions: true,
        center: true,
        quality: 3,
      }, {
        fullSize: true,
      });
    }
    ,
    setFocus() {
      // TODO find a better option that nextTick
      this.$nextTick(() => {
        if (this.$refs.articleNumberInput) {
          this.$refs.articleNumberInput.focus();
        }
      });
    }
    ,
    resetChanges() {
      db.customfields.where('magazineId').equals(this.page.magazineId)
          .and(row => row.pagePosition === this.page.pagePosition)
          .and(row => row.productId === this.product.productId)
          .delete()

      this.product.productCustomFields.forEach(item => {

        this.productData.customFields[item.field.trim()].value = item.value;
        this.productData.customFields[item.field.trim()].highlight = false;
      });

      this.productData.productLogos = JSON.parse(JSON.stringify(this.resetProductData.productLogos));
      this.productData.productPictures = JSON.parse(JSON.stringify(this.resetProductData.productPictures));
      this.productData.productTemplate.id = this.resetProductData.productTemplate.id;
      this.productData.productTemplate.highlight = false;

      reloadHighlights();

      this.triggerFormEvent('reset', this.productData);
    },

    resetHighlight() {
      this.productData.productPictures.forEach((item, index) => {
        item.highlight = false;
      });
      this.productData.productLogos.forEach((item, index) => {
        item.highlight = false;
      });
      for (const [key, value] of Object.entries(this.productData.customFields)) {
        value.highlight = false;
      }
      this.productData.productTemplate.highlight = false;
    },

    onRemoveImage(image) {
      image.addet = false;
      image.highlight = true;
      image.delete =  false
      image.isRemoved = !image.isRemoved;
      this.saveProductAssets();
    }
    ,
    onSetDeleteImage(image) {
      // JE NACH DEM OB MEIN BEIM AUF LÖSCHEN SETZEN EINE MELDUNG HABEN MÖCHTE ODER NICHT NIMMT MAN DEN CODE UNTEN
      /*
      if (!image.markedForDeletion) {
        eventBus.openModal(ConfirmAction, {
          title: "Bild löschen",
          message: "Sind Sie sicher, dass Sie dieses Bild auf löschen setzen möchten?",
          onAccept: () => {
            image.highlight = true;
            image.markedForDeletion = !image.markedForDeletion;
            this.saveProductAssets();
          },
          onCancel: () => {
          }
        });
      }else{
        image.highlight = true;
        image.markedForDeletion = !image.markedForDeletion;
        this.saveProductAssets();
      }*/
      image.addet = false;
      image.highlight = true;
      image.markedForDeletion = !image.markedForDeletion;
      this.saveProductAssets();
    },
    onChangeActiveImage(image) {
      image.addet = false;
      image.highlight = true;
      image.isActive = !image.isActive;
      this.saveProductAssets();
    },
    onChangeDefaultImage(image) {
      image.addet = false;
      image.highlight = true;
      this.productData.productPictures.forEach((item, index) => {
        if (image.productPictureId !== item.productPictureId && item.isDefault) {
          item.highlight = true;
          item.isDefault = false;
        }
      });
      this.saveProductAssets();
    },
    onZoomImage(picture, type) {
      function mapItems(data, type) {
        return data.map((item) => ({
          previewSmall: item.previewSmall,
          previewLarge: item.previewLarge,
          type: type,
          id: type === 'picture' ? item.productPictureId : item.productLogoId,
          name: item.name,
          dateTimeCreated: item.dateTimeCreated,
          dateTimeUpdated: item.dateTimeUpdated,
        }));
      }

      let pictures = [];
      let selectedIndex = 0;
      console.log("type", type)
      if (type == 'picture') {
        pictures = mapItems(this.productData.productPictures, 'picture');
        selectedIndex = pictures.findIndex((item) => item.id === picture.productPictureId);
      } else if (type == 'logo') {
        pictures = mapItems(this.productData.productLogos, 'logo');
        selectedIndex = pictures.findIndex((item) => item.id === picture.productLogoId);
      }

      eventBus.openModal(ImageView, {
        pictures: pictures,
        selectedIndex: selectedIndex,
        showButton: false,
      }, {halfSize: true});
    },
    onSortImages(images) {
      images.forEach((item, index) => {
        item.position = index + 1;
        if (item.orignalPosition !== item.position) {
          item.highlight = true;
        }
      });
     this.saveProductAssets();
    },
    getFieldValue(fieldName, type) {
      if (type === 'boolean') {
        const boolean = this.productData.customFields[fieldName]?.value === 'yes';
        return boolean;
      }
      return this.productData.customFields[fieldName]?.value || '';
    }
    ,
    changeArticleNumber() {
      this.changeArticleNumberDialog = !this.changeArticleNumberDialog;
    }
    ,
    async saveNewArticleNumber(articleNumber) {

      if (articleNumber == this.oldArticleNumber) {
        this.changeArticleNumberDialog = false;
        return;
      }

      const mutation = gql`
        mutation saveNewArticleNumber($articleNumber: String!, $oldArticleNumber: String!) {
           saveNewArticleNumber(articleNumber: $articleNumber, oldArticleNumber: $oldArticleNumber) {
              success
            code
            message

           }
        }
      `;
      try {
        const variables = {
          articleNumber: articleNumber,
          oldArticleNumber: this.oldArticleNumber
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.saveNewArticleNumber.success) {

          if (data.saveNewArticleNumber.code == "ARTICLE_NUMBER_EXISTS") {
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Die neue Artikelnummer existiert bereits",
              message: "Die Artikelnummer konnte nicht geändert werden",
            });
            this.changeArticleNumberDialog = false;
            this.productData.articleNumber = this.oldArticleNumber;

          } else {
            this.oldArticleNumber = articleNumber;
            this.changeArticleNumberDialog = false;
            this.onClickReloadPage();
          }
        }
      } catch (error) {
        console.error("fehler beim clipboard zuweisen", error);
      }

    }
    ,
    async sendProductToClipboard() {

      if (this.product.isVirtualArticle) {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Artikel nicht für die Zwischenablage verfügbar",
          message: "Dieser Artikel is für die Zwischenablage nicht verfügbar",
        });
        return;
      }
      const clipboardData = {
        pageID: this.page.pageId,
        productID: this.product.productId,
        virtualId: this.product.placeholderId,
      }
      const mutation = gql`
        mutation editClipboard($clipboard: EditClipboardInput!) {
           editClipboard(clipboard: $clipboard) {
            success
          }
        }
      `;
      try {
        const variables = {
          clipboard: clipboardData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit("reload-clipboard",);
        SignalBus.emit("formular-reload-clipboard")
        // this.onClickReloadPage();
      } catch (error) {
        console.error("fehler beim clipboard zuweisen", error);
      }
    }
    ,
    switchForm(selectedFormId) {
      this.selectedFormId = selectedFormId;
      this.getFormular();
    }
    ,
    async getFormular() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getFormular($selectedFormId: Int!) {
              getFormular(formularID: $selectedFormId) {
                id
                groupID
                formularType
                label
                value
                image
                readOnly
                field
              }
            }
          `,
          variables: {
            selectedFormId: this.selectedFormId
          }
        });
        this.formData = response.data.getFormular;
        this.formData.forEach((item, index) => {
          if (this.productData.customFields[item.field] === undefined) {
            this.productData.customFields[item.field] = {value: '', highlight: false};
          }
        });

      } catch (error) {
        console.error("Fehler beim Abrufen der getFormInfos:", error);
      }
    }
    ,
    async loadUserChanges() {
      try {

        const results = await db.customfields.where('magazineId').equals(this.page.magazineId).and(field => field.pagePosition === this.page.pagePosition && field.productId === this.product.productId).toArray();
        results.forEach(item => {

          if (this.productData.customFields[item.key]?.value === undefined) {
            this.productData.customFields[item.key] = {value: '', highlight: false};
          }

          if (item.type === 'field') {
            this.productData.customFields[item.key].value = item.value;
            this.productData.customFields[item.key].highlight = true;
          }
          if (item.type === 'template') {
            this.productData.productTemplate.id = item.value;
            this.productData.productTemplate.highlight = true;
          }
          if (item.type === 'picture') {

            let pictures = JSON.parse(item.value);
            pictures.forEach((item, index) => {
              let pIndex = -1;
              this.productData.productPictures.forEach((p, i) => {
                if (p.productPictureId === item.productPictureId) {
                  pIndex = i;
                }
              });

              if (pIndex !== -1) {
                this.productData.productPictures[pIndex].highlight = true;
                this.productData.productPictures[pIndex].isDefault = item.isDefault;
                this.productData.productPictures[pIndex].markedForDeletion = item.markedForDeletion;
                this.productData.productPictures[pIndex].position = item.position;
                this.productData.productPictures[pIndex].previewSmall = item.previewSmall;
                this.productData.productPictures[pIndex].previewMedium = item.previewMedium;
                this.productData.productPictures[pIndex].previewLarge = item.previewLarge;
                this.productData.productPictures[pIndex].productJoinProductPictureId = item.productJoinProductPictureId;
                this.productData.productPictures[pIndex].productPictureId = item.productPictureId;
                this.productData.productPictures[pIndex].isActive = item.isActive;
                this.productData.productPictures[pIndex].isRemoved = item.isRemoved;
              } else {
                this.productData.productPictures.unshift(item);
              }
            });

            //sort pictures
            this.productData.productPictures.sort((a, b) => {
              return a.position - b.position;
            });

          }

          if (item.type === 'logo') {
            let logos = JSON.parse(item.value);
            logos.forEach((item, index) => {
              let pIndex = -1;
              this.productData.productLogos.forEach((p, i) => {
                if (p.productLogoId === item.productLogoId) {
                  pIndex = i;
                }
              });
              if (pIndex !== -1) {
                this.productData.productLogos[pIndex].highlight = true;
                this.productData.productLogos[pIndex].isDefault = item.isDefault;
                this.productData.productLogos[pIndex].markedForDeletion = item.markedForDeletion;
                this.productData.productLogos[pIndex].position = item.position;
                this.productData.productLogos[pIndex].previewSmall = item.previewSmall;
                this.productData.productLogos[pIndex].previewMedium = item.previewMedium;
                this.productData.productLogos[pIndex].previewLarge = item.previewLarge;
                this.productData.productLogos[pIndex].productJoinProductLogoId = item.productJoinProductLogoId;
                this.productData.productLogos[pIndex].productLogoId = item.productLogoId;
                this.productData.productLogos[pIndex].isActive = item.isActive;
                this.productData.productLogos[pIndex].isRemoved = item.isRemoved;
              } else {
                this.productData.productLogos.unshift(item);
              }
            });

            //sort logos
            this.productData.productLogos.sort((a, b) => {
              return a.position - b.position;
            });
          }
        });
      } catch (err) {
        console.error("Fehler beim Abrufen der getFormInfos:", err);
      }
    },
    async onBlurProductField() {
      let h = this?.page?.hooks || [];
      h.forEach((script) => {
        hooks.runScript(script, {
          fieldName: '',
          type: '',
          value: '',
          productData: this.productData,
          product: this.product,
          page: this.page,
          changeProductFieldValue: this.changeProductFieldValue,
        });
      })
    },
    async onChangeProductFieldValue(fieldName, type, value) {
      event.preventDefault();
      if (value === undefined) {
        value = this.productData.customFields[fieldName].value;
      }

      if (type === undefined || type === null) {
        type = 'string';
      }
      this.productData.customFields[fieldName].value = type === 'boolean' ? value ? 'yes' : 'no' : value;
      this.productData.customFields[fieldName].highlight = true;
      await this.saveProductState('field', fieldName, this.productData.customFields[fieldName].value);

      customizations.runHook('onChangeProductFieldValue', {
        fieldName,
        type,
        value,
        productData: this.productData,
        product: this.product,
        page: this.page,
        changeProductFieldValue: this.changeProductFieldValue,
      });

      let h = this?.page?.hooks || [];
      h.forEach((script) => {
        hooks.runScript(script, {
          fieldName,
          type,
          value,
          productData: this.productData,
          product: this.product,
          page: this.page,
          changeProductFieldValue: this.changeProductFieldValue,
        });
      })


      reloadHighlights();
    },
    async changeProductFieldValue(fieldName, type, value) {
      if (value === undefined) {
        value = this.productData.customFields[fieldName].value;
      }

      if (type === undefined || type === null) {
        type = 'string';
      }

      this.productData.customFields[fieldName].value = type === 'boolean' ? value ? 'yes' : 'no' : value;
      this.productData.customFields[fieldName].highlight = true;
      await this.saveProductState('field', fieldName, this.productData.customFields[fieldName].value);

      customizations.runHook('onChangeProductFieldValue', {
        fieldName,
        type,
        value,
        productData: this.productData,
        product: this.product,
        page: this.page,
      })
      reloadHighlights();
    },
    async saveProductState(type, key, value) {
      if (!this.useIndexDB) {
        if (key == "pictures" || key == "logos") {
          value = JSON.parse(value);
        }
        this.changes[key] = {type: type, key: key, value: value};
        this.onChange(this.changes);
        return;
      }

      await db.transaction('rw', db.customfields, async () => {
        // Überprüfen, ob das Feld bereits existiert
        const existingField = await db.customfields
            .where('magazineId').equals(this.page.magazineId)
            .and(field => field.pagePosition === this.page.pagePosition && field.productId === this.product.productId && field.key === key)
            .first();

        // Wenn es nicht existiert, erstellen, sonst aktualisieren
        if (!existingField) {
          await db.customfields.add({
            projectId: this.page.projectId,
            magazineId: this.page.magazineId,
            pagePosition: this.page.pagePosition,
            productId: this.product.productId,
            articleNumber: this.product.articleNumber,
            marketIds: JSON.stringify(this.product.marketIds),
            type: type,
            key: key,
            value: value,
          });
        } else {
          await db.customfields.update(existingField.id, {value: value});
        }
      }).catch(err => {
        console.error(err.stack || err);
      });
      reloadHighlights();
    },

    /*
    async saveProductState(type, key, value) {
      //check if field already exists
      const existingField = await db.customfields
          .where('magazineId').equals(this.page.magazineId)
          .and(field => field.pagePosition === this.page.pagePosition && field.productId === this.product.productId && field.key === key)
          .first();

      //if not, create it else update it
      if (!existingField) {
        await db.customfields.add({
          projectId: this.page.projectId,
          magazineId: this.page.magazineId,
          pagePosition: this.page.pagePosition,
          productId: this.product.productId,
          articleNumber: this.product.articleNumber,
          marketIds: JSON.stringify(this.product.marketIds),
          type: type,
          key: key,
          value: value,
        });
      } else {
        db.customfields.update(existingField.id, {value: value});
      }
    },
    */

    saveProductAssets() {
      let pictures = this.productData.productPictures.filter((item) => item.highlight);
      if (pictures.length > 0) {
        this.saveProductState('picture', 'pictures', JSON.stringify(pictures));
      }

      let logos = this.productData.productLogos.filter((item) => item.highlight);
      if (logos.length > 0) {
        this.saveProductState('logo', 'logos', JSON.stringify(logos));
      }
    }
    ,
    async deleteProduct() {
      const query = gql`
        query deleteProductFromPage($pageId: Int!, $articleNumber: String!,$productId: Int !, $virtualId: Int!) {
          deleteProductFromPage(pageId: $pageId, articleNumber: $articleNumber, productId: $productId, virtualId: $virtualId) {
            success
            }
        }
      `;

      const variables = {
        pageId: parseInt(this.page.pageId),
        articleNumber: this.product.articleNumber,
        productId: parseInt(this.product.productId),
        virtualId: parseInt(this.product.placeholderId)
      };

      try {
        const {data} = await apolloClient.query({query, variables});
        this.resetChanges();
        this.onClickReloadPage();

      } catch (error) {
      }
    },
    placeProductFromOtherMagazine() {
      eventBus.openModal(PlaceProductFromOtherMagazine, {
        page: this.page,
        virtualId: this.product.placeholderId,
        title: "Virtuellen Artikel verknüpfen",

      });
    },
    async placeProduct(event ,verschmelzen) {

      if (this.articleNumber === "") {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Artikelnummer fehlt",
          message: "Sie müss zuerst eine artikelnummer eingeben ",
        });
        return;
      }
      if (verschmelzen) {
        this.placeABCArticle = true;
      }
      let articleNumbersArray = this.articleNumber.split(/[,;\n]+/).map(num => num.trim());

      //remove empty strings
      articleNumbersArray = articleNumbersArray.filter((item) => item !== "");

      await this.placeProducts(articleNumbersArray);

    },
    async placeProductByRule(rule) {
      const query = gql`
        query placeProductByRule($pageId: Int!, $articleNumber: String!, $placeholderId: Int!,$rule : Int!) {
          placeProductByRule(pageId: $pageId, articleNumber: $articleNumber, placeholderId: $placeholderId, rule: $rule) {
            success
            code
            message
            values {
              key
              value
            }
          }
        }
      `;

      const variables = {
        pageId: parseInt(this.page.pageId),
        articleNumber: this.articleNumber.replace(/\s/g, ''),
        placeholderId: this.product.placeholderId,
        rule: rule
      };
      try {
        const {data} = await apolloClient.query({query, variables});
        if (data.placeProductByRule.success == true) {
          this.onClickReloadPage();
          SignalBus.emit("reload-clipboard");
          SignalBus.emit("formular-reload-clipboard");
        }

      } catch (error) {
        console.error("fehler beim Platzieren der seite", error)
      }
    }
  },
  mounted() {

    this.getPurchasers();
    // Initialize drag-and-drop handling from the preload script
    window.addEventListener('dragover', this.preventDefault, false);
    window.addEventListener('drop', this.preventDefault, false);

    this.getFormular();
    SignalBus.connect(this, "set_focus", this.setFocus);
    SignalBus.connect(this, 'resetHighlights', this.resetHighlight);
    SignalBus.connect(this, "assign-template-to-product", (template) => {

      if (this.isPageLocked) {
        return;
      }

      if (this.active) {
        this.productData.productTemplate.id = template.templateId;
        this.productData.productTemplate.highlight = true;
        this.saveProductState('template', 'template', template.templateId);
      }
    })

    SignalBus.connect(this, "assign-picture-to-product", (data) => {

      if (this.isPageLocked) {
        return;
      }

      if (this.active) {
        let exists = false;
        console.log("productData.productPictures", JSON.parse(JSON.stringify(this.productData.productPictures)))
        console.log("data", JSON.parse(JSON.stringify(data)))
        if (data.type.toString() === "picture") {
          this.productData.productPictures.forEach((item) => {
            if (item.previewSmall === data.previewSmall) {
              exists = true;
            }
          });

        } else if (data.type.toString() === "logo") {
          this.productData.productLogos.forEach((item) => {
            if (item.previewSmall === data.previewSmall) {
              exists = true;
            }
          });
        }
        if (exists) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Bild bereits vorhanden",
            message: "Das Bild ist bereits vorhanden",
          });
          return;
        }
        if (data.type == "picture") {
          this.productData.productPictures.unshift({
            productJoinProductPictureId: 0,
            productPictureId: 0,
            pictureId: data.id,
            previewSmall: data.previewSmall,
            previewMedium: data.previewMedium,
            previewLarge: data.previewLarge,
            isActive: true,
            position: 0,
            markedForDeletion: data.isDeleted || false,
            isDefault: false,
            highlight: true,
            isRemoved: false,
          });
          this.onSortImages(this.productData.productPictures);
        } else if (data.type == "logo") {
          this.productData.productLogos.unshift({
            productJoinProductLogoId: 0,
            productLogoId: 0,
            pictureId: data.id,
            previewSmall: data.previewSmall,
            previewMedium: data.previewMedium,
            previewLarge: data.previewLarge,
            isActive: true,
            position: 0,
            markedForDeletion: data.isDeleted || false,
            highlight: true,
            isRemoved: false,
          });
          this.onSortImages(this.productData.productLogos);
        }
        this.saveProductAssets();
      } else {
        // open modal

      }
    });

  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
  unmounted() {
    window.removeEventListener('dragover', this.preventDefault, false);
    window.removeEventListener('drop', this.preventDefault, false);

    //SignalBus.disconnect("assign-template-to-product");
    //SignalBus.disconnect("assign-picture-to-product");
    SignalBus.connect(this, 'article-created', this.getFormular);
    SignalBus.connect(this, 'reload-page', this.onClickReloadPage);
    this.getPurchasers();
  },
  async created() {

    await this.loadUserChanges();
    this.picturePositionSave = JSON.parse(JSON.stringify(this.productData.productPictures));

    this.ready = true;

    await this.getFormular();
    await this.setFocus();

  },
  beforeDestroy() {
    this.disconnect();
  }
}
</script>
